import refs from '../helpers/refs'

class CProductAccordion {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-product-accordion')
    .forEach(el => new CProductAccordion(el))
})
